import React from 'react';
import { ACCOUNT_HUB_URL } from 'gatsby-env-variables';

import ButtonLink from '../../components/ButtonLink/ButtonLink.jsx';

import './Cta.scss';

class CtaSection extends React.Component {
  render() {
    const { ctaButtonCopy } = this.props;
    return (
      <div className='cta-section'>
        <div className='cta-section-wrapper'>
          <div className='cta-text'>
            <h2>Simply sign up online and we'll do all the hard work for you.</h2>
          </div>
          <div className='cta-button'>
            <ButtonLink type='submit' title={ctaButtonCopy} buttonStyles={styles.buttonWrapperStyles} href={`${ACCOUNT_HUB_URL}/signup`}></ButtonLink>
          </div>
        </div>
      </div>
    );
  }
}

export default CtaSection;

const styles = {
  buttonWrapperStyles: {
    color: 'white',
  },
};
